import React, {useState} from 'react';
import useDidMountEffect from "../../utils/useDidMountEffect";
import useAfterUpdateEffect from "../../utils/useAfterUpdateEffect";

const ParamsWrapper = props => {
  const [params, setParams] = useState(props.match.params[0].split('/').filter(v => v !== ''))

  useDidMountEffect(() => {
    setParams(props.match.params[0].split('/').filter(v => v !== ''))
  })

  useAfterUpdateEffect(() => {
    setParams(props.match.params[0].split('/').filter(v => v !== ''))
  }, [props.match.params])

  return <props.component
    params={params}
  />
};

ParamsWrapper.propTypes = {

};

export default ParamsWrapper;